import { render, staticRenderFns } from "./NoteTab.vue?vue&type=template&id=5ce0c960"
import script from "./NoteTab.vue?vue&type=script&lang=js"
export * from "./NoteTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports